import React, { useEffect, useMemo, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartLine } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import useMerchantSalesOverviewAPI, {
  getDefaultSalesRange,
} from "../../../api/merchantSalesOverviewAPI";
import SalesFilters from "./SalesFilters";
import SalesSummaryCards from "./SalesSummaryCards";
import SalesChartSection from "./SalesChartSection";
import "../../../Styles/pages/sales-overview.scss";

export default function SalesOverviewPage() {
  const salesOverviewSummary = useSelector(
    (state) => state.app?.summary?.salesOverview || {},
  );
  const salesOverviewLoadingRedux = useSelector((state) =>
    Boolean(state.app?.tables?.salesOverview?.loading),
  );
  const { error, getTotalSales, loading, merchantSales, salesChart } =
    useMerchantSalesOverviewAPI();
  const [dateRange, setDateRange] = useState(getDefaultSalesRange);

  useEffect(() => {
    getTotalSales(dateRange).catch(() => {});
  }, [dateRange, getTotalSales]);

  const effectiveMerchantSales =
    salesOverviewSummary?.totalSalesRecords || merchantSales;
  const effectiveSalesChart =
    salesOverviewSummary?.merchantSalesCharts || salesChart;
  const effectiveLoading = salesOverviewLoadingRedux || loading;

  const totals = useMemo(
    () => ({
      USD: effectiveMerchantSales?.[0]?.TotalSales ?? 0,
      LBP: effectiveMerchantSales?.[1]?.TotalSales ?? 0,
    }),
    [effectiveMerchantSales],
  );

  const chartData = useMemo(
    () => ({
      USD: effectiveSalesChart?.[0]?.ChartsPoints || [],
      LBP: effectiveSalesChart?.[1]?.ChartsPoints || [],
    }),
    [effectiveSalesChart],
  );

  return (
    <section className="new-page-shell sales-overview-page">
      <div className="sales-overview-page__heading">
        <div className="sales-overview-page__title-block">
          <span className="sales-overview-page__icon" aria-hidden="true">
            <FontAwesomeIcon icon={faChartLine} />
          </span>
          <div>
            <h1>Sales Overview</h1>
            <p>Track merchant sales totals and trends across your selected date range.</p>
          </div>
        </div>
      </div>

      <SalesFilters dateRange={dateRange} onDateRangeChange={setDateRange} />

      {error ? <div className="sales-overview-page__error">{error}</div> : null}

      <SalesSummaryCards loading={effectiveLoading} totals={totals} />

      <SalesChartSection
        chartData={chartData}
        dateRange={dateRange}
        loading={effectiveLoading}
      />
    </section>
  );
}
